import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
//import { useParams } from 'react-router-dom'

import { Message, Panel } from 'rsuite'
// import { Checkbox, CheckboxGroup } from 'rsuite';
import { IconButton, Icon } from 'rsuite'
import { Row } from 'rsuite'
import AdministrativeArea from './AdministrativeArea'
import AdministrativeAreaView from './AdministrativeAreaView'
import scrollToComponent from 'react-scroll-to-component'
import { saveTargetArea, saveSubProjectTargetArea } from '../../../redux/actions/targetSetting'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar, getSchemaSubProjectSidebar } from '../../../redux/actions/sidebar'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'

export default function AdministrativeAreaWidget(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit, isSubProject } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(schema)
  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleUpdateSave = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      console.log('call save.')
      const response = await saveTargetArea(id, request)
      console.log('response', response)

      if (response) {
        setFormSchema(response.model)
        // setFormSchema(response)
        onChangeIsEdit(false)
        await dispatch(getSchemaSidebar(id))
      } else {
        setIsError(true)
      }
      // setIsError(true)
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpdateSaveSubProject = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      console.log('call save.')
      const response = await saveSubProjectTargetArea(id, request)
      console.log('response', response)

      if (response) {
        setFormSchema(response)
        // setFormSchema(response)
        onChangeIsEdit(false)
        await dispatch(getSchemaSubProjectSidebar(id))
      } else {
        setIsError(true)
      }
      // setIsError(true)
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let request = {
      locationList: data.areaList || [],
    }

    // console.log('request', request)
    if (isSubProject) {
      handleUpdateSaveSubProject(projectId, request)
    } else {
      handleUpdateSave(projectId, request)
    }
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      defaultExpanded
      collapsible
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? (
        <AdministrativeArea
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      ) : (
        <AdministrativeAreaView schema={formSchema} />
      )}

      {showCommandButton && (
        <>
          <hr />

          {isEdit ? (
            <div>
              {isError && (
                <Row style={{ marginBottom: '1em' }}>
                  <Message
                    showIcon
                    type="error"
                    description={
                      'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
                    }
                  />
                </Row>
              )}

              <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading}></SaveButton>
              <CancelButton
                onClick={() => {
                  onChangeIsEdit(!isEdit)
                  setIsError(false)
                }}
                disabled={isLoading}
              ></CancelButton>
            </div>
          ) : (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-edit"
              onClick={() => {
                onChangeIsEdit(!isEdit)
                setIsError(false)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
              disabled={isLoading}
            >
              แก้ไข{formSchema.header}
            </IconButton>
          )}
        </>
      )}
    </Panel>
  )
}
